import React, { useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/form/TextInput';
import PasswordInput from '../../components/form/PasswordInput';
import Button from '../../components/form/Button';
import LangSwitcher from '../../components/shared/LangSwitcher';
import FormContainer from '../../containers/FormContainer';
import { register } from '../../services/apiService';
import usePageTitle from '../../helpers/usePageTitle';

const Register = ({ changeLanguage }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [isFormLoading, setIsFormLoading] = useState(false);
  const [formError, setFormError] = useState(null);
  const [signUpForm, setSignUpForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: ''
  });




  const handleRegister = async() => {
    register(signUpForm, setIsFormLoading, setSignUpForm, setFormError);
  }

  usePageTitle("sign_up");

  return (
    <div className='min-h-screen bg-white'>
      <div className='max-w-[420px] mx-auto px-[15px] pt-[64px] pb-[100px]'>
        <img src="/assets/images/logo.svg" alt="ABMFY" className='h-[64px] mb-[48px]' />
        <div className='text-tprimary text-[28px] font-[700] leading-[34px] mb-[32px] rubik'>{t('sign_up')}</div>
        <FormContainer isLoading={isFormLoading} error={formError} onSubmit={handleRegister}>
          <div>
            <div className='flex justify-center gap-x-[16px]'>
              <div className='w-[50%]'>
                <TextInput label={t('first_name')} placeholder={t('first_name')} value={signUpForm.firstName} onChange={(e) => setSignUpForm({ ...signUpForm, firstName: e.target.value })} />
              </div>
              <div className='w-[50%]'>
                <TextInput label={t('last_name')} placeholder={t('last_name')} value={signUpForm.lastName} onChange={(e) => setSignUpForm({ ...signUpForm, lastName: e.target.value })} />
              </div>
            </div>
            <TextInput label={t('email')} placeholder={t('email')} value={signUpForm.email} onChange={(e) => setSignUpForm({ ...signUpForm, email: e.target.value })} />
            <PasswordInput label={t('password')} placeholder={t('password')} value={signUpForm.password} onChange={(e) => setSignUpForm({ ...signUpForm, password: e.target.value })} />
            <div className='flex justify-center gap-x-[16px] mt-[8px]'>
              <div className='w-full'>
                <Button onClick={handleRegister} disabled={signUpForm.firstName?.toString().length === 0 || signUpForm.lastName?.toString().length === 0 || signUpForm.email?.toString().length === 0 || signUpForm.password?.toString().length === 0} label={t('sign_up')} />
              </div>
            </div>
            <div className='text-[start] cursor-pointer mt-[24px]'>
              <div className='inline-block text-tprimary text-[14px] font-[500] leading-[18px] rubik'>
                {t('login_with_google')}
              </div>
              <img src="/assets/images/google.svg" alt="login with google" className='w-[40px] h-[40px] inline-block align-middle ms-[14px]' />
            </div>
          </div>
          <LangSwitcher i18n={i18n} changeLanguage={changeLanguage} />
        </FormContainer>
      </div>
    </div>
  );
};

export default Register;
